import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './ag-theme-ela.css';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc',
  },
};

const troubleTicketColumns = [
  { headerName: 'Ticket #', field: 'troubleTicketNumber', width: 80 },
  { headerName: 'Priority', field: 'priority', width: 80 },
  { headerName: 'Status', field: 'troubleTicketStatus', width: 100 },
  { headerName: 'Category', field: 'category', width: 120 },
  { headerName: 'Client', field: 'clientAbbrv', width: 100 },
  { headerName: 'Job #', field: 'jobNum', width: 70 },
  {
    headerName: 'Assigned To',
    field: 'assignedToLastName',
    width: 110,
    valueGetter: (params) => {
      const fn = params.data?.assignedToFirstName || '';
      const ln = params.data?.assignedToLastName || '';
      return fn ? `${fn} ${ln}`.trim() : '';
    },
  },
  {
    headerName: 'Description',
    field: 'description',
    width: 200,
    tooltipField: 'description',
  },
  {
    headerName: 'Due Date',
    field: 'dueDate',
    width: 100,
    valueFormatter: (params) =>
      params.value ? moment(params.value).format('MM/DD/YYYY') : '',
  },
  {
    headerName: 'Created By',
    field: 'createdByLastName',
    width: 110,
    valueGetter: (params) => {
      const fn = params.data?.createdByFirstName || '';
      const ln = params.data?.createdByLastName || '';
      return fn ? `${fn} ${ln}`.trim() : '';
    },
  },
  {
    headerName: 'Created',
    field: 'createDateTime',
    width: 100,
    valueFormatter: (params) =>
      params.value ? moment(params.value).format('MM/DD/YYYY') : '',
  },
];

export class TroubleTicketTableDefault extends Component {
  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;

    this.onGridReady = this.onGridReady.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text',
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });
      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  autoSizeUnspecifiedColumns = () => {
    if (!this.gridColumnApi) return;
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: troubleTicketColumns,
      rowData: this.props.troubleTickets,
      animateRows: true,
      defaultColDef: defaultColDef,
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.props.handleDoubleClick,
      onRowClicked: this.props.handleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '400px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}
